import React from "react";
import { Inbox } from "lucide-react";

const EmptyState = ({ icon: Icon = Inbox, title = "Nothing here yet", description, action }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-ink-100 dark:bg-ink-800">
      <Icon className="h-6 w-6 text-ink-400 dark:text-ink-400" />
    </div>
    <div>
      <p className="text-sm font-medium text-ink-700 dark:text-ink-200">{title}</p>
      {description && <p className="mt-1 text-sm text-ink-400 dark:text-ink-500">{description}</p>}
    </div>
    {action}
  </div>
);

export default EmptyState;
